var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusSignLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1113 11.385H12.955V4.22868C12.9425 4.02923 12.8545 3.84203 12.7089 3.70519C12.5632 3.56836 12.3709 3.49219 12.1711 3.49219C11.9712 3.49219 11.7789 3.56836 11.6332 3.70519C11.4876 3.84203 11.3996 4.02923 11.3871 4.22868V11.385H4.22771C4.02826 11.3975 3.84105 11.4855 3.70422 11.6312C3.56738 11.7768 3.49121 11.9691 3.49121 12.169C3.49121 12.3688 3.56738 12.5611 3.70422 12.7068C3.84105 12.8524 4.02826 12.9404 4.22771 12.9529H11.3841V20.1123C11.3965 20.3118 11.4845 20.499 11.6302 20.6358C11.7758 20.7726 11.9682 20.8488 12.168 20.8488C12.3678 20.8488 12.5602 20.7726 12.7058 20.6358C12.8515 20.499 12.9395 20.3118 12.9519 20.1123V12.956H20.1113C20.3108 12.9435 20.498 12.8555 20.6348 12.7098C20.7717 12.5642 20.8478 12.3719 20.8478 12.172C20.8478 11.9722 20.7717 11.7799 20.6348 11.6342C20.498 11.4886 20.3108 11.4006 20.1113 11.3881",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusSignLogo);
export default __webpack_public_path__ + "static/media/plus-sign-logo.073384210f7eec7db5807ea8a6fea774.svg";
export { ForwardRef as ReactComponent };